/***
 * ウィンドウサイズ
 *
 * css: --window-width
 * ウインドウサイズが変更されたら、再設定する
 */
export class WindowSize {
  constructor() {
    this.init();
  }

  private init(): void {
    this.setViewportWidth();
    this.addResizeListener();
  }

  private setViewportWidth(): void {
    // clientWidthを使用してスクロールバーを除いた幅を取得
    const viewportWidth = document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--window-width',
      `${viewportWidth}px`
    );
  }

  private addResizeListener(): void {
    window.addEventListener('resize', () => {
      this.setViewportWidth();
    });
  }
}

/***
 * ウィンドウサイズを管理するマネージャークラス
 */
export class WindowSizeManager {
  private windowSize: WindowSize;

  constructor() {
    this.windowSize = new WindowSize();
  }

  public getWindowSize(): WindowSize {
    return this.windowSize;
  }
}
